import React from 'react';
import {
  Input,
  Select,
  Checkbox,
  Radio,
  Upload,
  Space,
  Typography,
  Row,
  Col
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Option } = Select;

const FormFieldRenderer = ({ field, preview = false, value, onChange, disabled = false }) => {
  const { fieldType, label, description, placeholder, required, options = [], size = 'medium' } = field;

  const renderField = () => {
    switch (fieldType) {
      case 'textbox':
        return (
          <Input
            placeholder={placeholder || 'Enter text...'}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={disabled || preview}
            size={size}
          />
        );

      case 'dropdown':
        return (
          <Select
            placeholder={placeholder || 'Select an option...'}
            value={value}
            onChange={onChange}
            disabled={disabled || preview}
            size={size}
            style={{ width: '100%' }}
          >
            {options.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        );

      case 'checkbox':
        return (
          <Checkbox
            checked={value}
            onChange={(e) => onChange?.(e.target.checked)}
            disabled={disabled || preview}
          >
            {label}
          </Checkbox>
        );

      case 'checkbox-list':
        return (
          <Checkbox.Group
            options={options.map(opt => ({ label: opt.label, value: opt.value }))}
            value={value || []}
            onChange={onChange}
            disabled={disabled || preview}
          />
        );

      case 'yes-no':
        return (
          <Radio.Group
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={disabled || preview}
          >
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        );

      case 'file-upload':
        return (
          <Upload
            disabled={disabled || preview}
            beforeUpload={() => false} // Prevent auto upload in preview
            onChange={(info) => onChange?.(info.fileList)}
          >
            <Space>
              <UploadOutlined />
              Choose File
            </Space>
          </Upload>
        );

      case 'address':
        return (
          <div>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Input
                  placeholder="Street Address"
                  disabled={disabled || preview}
                  size={size}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="City"
                  disabled={disabled || preview}
                  size={size}
                />
              </Col>
              <Col span={6}>
                <Input
                  placeholder="State"
                  disabled={disabled || preview}
                  size={size}
                />
              </Col>
              <Col span={6}>
                <Input
                  placeholder="ZIP"
                  disabled={disabled || preview}
                  size={size}
                />
              </Col>
            </Row>
          </div>
        );

      default:
        return <Input placeholder="Unsupported field type" disabled />;
    }
  };

  if (fieldType === 'checkbox') {
    // For checkbox, the label is part of the checkbox itself
    return (
      <div>
        {renderField()}
        {description && (
          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: 4 }}>
            {description}
          </Text>
        )}
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        <Text strong>
          {label}
          {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
        </Text>
        {description && (
          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: 2 }}>
            {description}
          </Text>
        )}
      </div>
      {renderField()}
    </div>
  );
};

export default FormFieldRenderer;
